
const SERVICE_IDENTIFIERS = {
  Container: Symbol.for('container'),
  IAuthenticationService: Symbol.for('IAuthenticationService'),
  IConfigurationService: Symbol.for('IConfigurationService'),
  IGameConfigurationService: Symbol.for('IGameConfigurationService'),
  IChatConfigurationService: Symbol.for('IChatConfigurationService'),
  IHttpService: Symbol.for('IHttpService'),
  IServerServiceFactory: Symbol.for('IServerServiceFactory'),
  IErrorService: Symbol.for('IErrorService'),
  ICatchUpDataFactory: Symbol.for('ICatchUpDataFactory'),
  IResetDataFactory: Symbol.for('IResetDataFactory'),
  ICallsDataFactory: Symbol.for('ICallsDataFactory'),
  IBoxNumbersDataFactory: Symbol.for('IBoxNumbersDataFactory'),
  INextGameDataFactory: Symbol.for('INextGameDataFactory'),
  IWinnersDataFactory: Symbol.for('IWinnersDataFactory'),
  IPrizeWinnerDataFactory: Symbol.for('IPrizeWinnerDataFactory'),
  ICommandShortcutService: Symbol.for('ICommandShortcutService'),
  ICommandShortcutHandlerProvider: Symbol.for('ICommandShortcutHandlerProvider'),
  IKeyboardShortcutService: Symbol.for('IKeyboardShortcutService'),
  IKeyboardShortcutHandlerProvider: Symbol.for('IKeyboardShortcutHandlerProvider'),
  IGameWinnersService: Symbol.for('IGameWinnersService'),
  IGameControllerFactory: Symbol.for('IGameControllerFactory'),
  BaseGameController: Symbol.for('BaseGameController'),
  HamsterRaceGameController: Symbol.for('HamsterRaceGameController'),
  Bingo75GameController: Symbol.for('Bingo75GameController'),
  Bingo75LinesGameController: Symbol.for('Bingo75LinesGameController'),
  BritainsBiggestBingoGameController: Symbol.for('BritainsBiggestBingoGameController'),
  SEBingo75GameController: Symbol.for('SEBingo75GameController'),
  CincoGameController: Symbol.for('CincoGameController'),
  ESCincoGameController: Symbol.for('ESCincoGameController'),
  ITCincoGameController: Symbol.for('ITCincoGameController'),
  ITBingo75GameController: Symbol.for('ITBingo75GameController'),
  TombolaRouletteController: Symbol.for('TombolaRouletteController'),
  PictureBingoGameController: Symbol.for('PictureBingoGameController'),
  ESPictureBingoGameController: Symbol.for('ESPictureBingoGameController'),
  PotionGameController: Symbol.for('PotionGameController'),
  HexGameController: Symbol.for('HexGameController'),
  IAlertWordsService: Symbol.for('IAlertWordsService'),
  Bingo40GameController: Symbol.for('Bingo40GameController'),
  Bingo60GameController: Symbol.for('Bingo60GameController'),
  TheMachineGameController: Symbol.for('TheMachineGameController'),
  BubbleBingoGameController: Symbol.for('BubbleBingoGameController'),
  WordSearchGameController: Symbol.for('WordSearchGameController'),
  DondBingoGameController: Symbol.for('DondBingoGameController'),
  IWinnersTrackerService: Symbol.for('IWinnersTrackerService'),
  IEventBusService: Symbol.for('IEventBusService'),
  IUserChatStatusService: Symbol.for('IUserChatStatusService'),
  IUserSearchServiceFactory: Symbol.for('IUserSearchServiceFactory'),
  IPersistedStore: Symbol.for('IPersistedStore'),
  IModalSpawnAgent: Symbol.for('IModalSpawnAgent'),
  IModalManagerService: Symbol.for('IModalManagerService'),
  IHtpConfigurationService: Symbol.for('IHtpConfigurationService'),
  ISweetAlertService: Symbol.for('ISweetAlertService'),
  ISoundService: Symbol.for('ISoundService'),
  ILocalisationService: Symbol.for('ILocalisationService'),
  IUserProfileService: Symbol.for('IUserProfileService'),
  IChatPrizeService: Symbol.for('IChatPrizeService'),
  ISinBanService: Symbol.for('ISinBanService'),
  ISafeplayService: Symbol.for('ISafeplayService'),
  ITechicalIssueService: Symbol.for('ITechnicalIssueService'),
  IUserNominationService: Symbol.for('IUserNominationService'),
  IPlayerNotesService: Symbol.for('IPlayerNotesService'),
  IChatContextMenuFactory: Symbol.for('IChatContextMenuFactory'),
  IArcadeAdminFeedServiceProvider: Symbol.for('IArcadeAdminFeedServiceProvider'),
  IAlertWordsMessageFormatter: Symbol.for('IAlertWordsMessageFormatter'),
  IServerConnectionLogger: Symbol.for('IServerConnectionLogger'),
  ITogglesService: Symbol.for('ITogglesService'),
  NLPictureBingoGameController: Symbol.for('NLPictureBingoGameController'),
  IDefaultMethodsService: Symbol.for('IDefaultMethodsService')
};

export { SERVICE_IDENTIFIERS };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/_ioc/service-identifiers.ts